<template>
    <v-container id="page-driver-detail">
        <div class="page-title">{{$route.name}}</div>

        <v-row>
            <v-col class="d-flex justify-end">
                <c-btn class="mx-1" color="blue" outlined @click="updateDriverDialog = true" iconName="mdi-pencil" :disabled="disabledByRole">수정
                </c-btn>
                <c-btn class="mx-1" color="grey" outlined @click="onDeleteDriver" iconName="delete" :disabled="disabledByRole">삭제</c-btn>
                <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)"
                       iconName="mdi-format-list-bulleted-square">
                    돌아가기
                </c-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="pt-0">
                <c-card>
                    <v-row justify="space-around" align="center">

                        <div style="width: calc(100% - 250px); margin-left:30px;">
                            <v-row align="center">
                                <v-col cols="12" sm="6" md="2">
                                    <span>이름</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="10" class="pt-0">
                                    <span class="black--text">{{driverInfo.name}}</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <span>생년월일</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <span class="black--text">{{driverInfo.birth?driverInfo.birth:""}}</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <span>성별</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <span class="black--text">{{$func.gender(driverInfo.gender, false)}}</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <span>주소</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="10">
                                    <span class="black--text">{{driverInfo.address}}</span>
                                </v-col>

                                <v-col cols="12" sm="6" md="2">
                                    <span>연락처</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <span class="black--text">{{driverInfo.mobileNo}}</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <span>근무상태</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <span class="black--text">{{this.driverInfo.onwork === 'T' ? '출근' : '퇴근'}}</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <span>배정 차량</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="10">
                                    <div class="black--text" v-if="vehicleList.length === 0">없음</div>
                                    <div v-else v-for="item in vehicleList" class="black--text">
                                        <span style="cursor: pointer" @click="$router.push(`/vehicle/${item.id}`);" >{{item.plateNo}}</span>
                                        <span class="ml-3">{{item.seatCnt.configName}}</span>
                                        <span class="ml-3">{{item.modelName}}</span>
                                    </div>
                                </v-col>

                                <v-col cols="12" sm="6" md="2">
                                    <span>운전자 등록번호</span>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <span class="black--text">{{driverInfo.licenseNo}}</span>
                                </v-col>

                            </v-row>
                        </div>
                        <c-card outlined style="min-width: 150px;">
                            <v-row justify="center" align="center">
                                <v-img v-if="driverInfo.photo" :src="$func.getImgUrl(this.driverInfo.photo)" aspect-ratio="1"></v-img>
                                <div v-else>
                                    <v-icon size="100">person</v-icon>
                                </div>
                            </v-row>
                        </c-card>
                    </v-row>
                </c-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <c-card title="예약 정보">
                    <v-sheet height="500">
                        <v-calendar
                                ref="calendar"
                                :events="events"
                                type="4day"
                                :firstInterval="7"
                                :intervalCount="17"
                                @change="reqReservationSchedule"
                                @click:event="reqReservation"
                                locale="ko"
                                color="primary"
                        ></v-calendar>
                    </v-sheet>
                </c-card>
            </v-col>
        </v-row>

        <reservation-detail-dialog
                :reservation-detail-info="reservationDetailInfo"
                :open.sync="reservationDetailDialog"/>

        <driver-c-u-dialog
                :open.sync="updateDriverDialog"
                :driverFormData="driverInfo"
                @reqUpdateDriver="reqUpdateDriver"
        />
    </v-container>
</template>
<script>
  import ReservationDetailDialog from "./ReservationDetailDialog";
  import DriverCUDialog from "./DriverCUDialog";
  import Login from "@/views/CallTaxi/Login";

  export default {
    components: {ReservationDetailDialog, DriverCUDialog},
    data() {
      return {
        param: this.$route.params.driverId,

        driverInfo: {
          driverId: '',
          id: '',
          name: '',
          gender: 'M',
          mobileNo: '',
          licenseNo: '',
          address: '',
          birth: '',
          onwork: 'T', //['T", 'F']
          plateNo: '',
          model: '',

          photo: null,
        },
        vehicleList: [],


        today: '',
        events: [],

        reservationDetailDialog: false,
        updateDriverDialog: false,

        reservationDetailInfo: {},

      }
    },

    computed: {
      disabledByRole() {
        return this.$store.state.userInfo.role === 'RM';
      },
    },
    methods: {
      reqGetState() {
        let state = this.reservationDetailInfo.state + 1;
        this.reservationDetailInfo.state = state % 6 || 1;
        if (this.reservationDetailDialog) {
          setTimeout(() => {
            if (this.reservationDetailDialog) this.reqGetState();
          }, 3000);
        }

      },
      async reqGetDriver() {
        try {
          const res = await this.$api.getDriver(this.param);
          this.driverInfo = res.data.driver;
          this.vehicleList = res.data.vehicleList;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetDriver'});
        }
      },
      async reqDeleteDriver() {
        try {
          const res = await this.$api.deleteDriver(this.param);

          this.$store.commit('alert', {open: true, timeout: 4000, msg: res.data});
          setTimeout(() => {
            this.$router.push('/drivers');
          }, 3000);

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDeleteDriver'});
        }
      },
      async reqUpdateDriver(data) {
        try {
          const res = await this.$api.updateDriver(data);
          this.updateDriverDialog = false;
          this.reqGetDriver();

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqUpdateDriver'});
        }
      },
      async onDeleteDriver() {
        // 주행 중인 예약 유무 확인
        if (await this.reqDrivingReservCheck()) {
          this.$store.commit('snackbar', {msg: '주행 중인 기사는 삭제가 불가능합니다.'});
          return;
        }

        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "기사를 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteDriver(this.driverInfo.id);
            }
          });
      },
      async reqReservation(item) {
        try {
          const res = await this.$api.getReservation(item.event.reservationId);
          this.reservationDetailInfo = res.data;
          this.reservationDetailDialog = true;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqReservation'});
        }
      },
      async reqReservationSchedule() {
        const start = this.$func.curDateString();
        const end = this.$func.curDateStringAddDays(4);

        try {
          const res = await this.$api.getReservationScheduleById(this.param, start, end);
          let apiResponse = res.data;

          for (const item of apiResponse) {
            this.events.push({
              reservationId: item.reservationId,
              name: item.resrvState.configName,
              start: item.startTime,
              end: item.endTime,
              color: 'orange'
            })
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqReservationSchedule'});
        }
      },
      async reqDrivingReservCheck() {
        try {
          const driverIds = [this.param];
          const res = await this.$api.checkDrivingReservation(driverIds);
          return res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDrivingReservCnt'});
        }
      }
    },
    mounted() {
      this.reqGetDriver();
    },
  }
</script>
<style lang="scss" scoped>
    .info-label {
        width: 100px;
    }
</style>
